import React from 'react';
import { FileCheck, CheckCircle, XCircle } from 'lucide-react';

interface DocumentValidationWorkflowStatsProps {
  pendingCount: number;
  approvedCount: number;
  rejectedCount: number;
}

export default function DocumentValidationWorkflowStats({
  pendingCount,
  approvedCount,
  rejectedCount,
}: DocumentValidationWorkflowStatsProps) {
  const statCards = [
    {
      label: 'Pending',
      value: pendingCount,
      icon: FileCheck,
      iconColor: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-l-amber-500',
    },
    {
      label: 'Approved',
      value: approvedCount,
      icon: CheckCircle,
      iconColor: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      borderColor: 'border-l-emerald-500',
    },
    {
      label: 'Rejected',
      value: rejectedCount,
      icon: XCircle,
      iconColor: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-l-red-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
      {statCards.map(stat => (
        <div
          key={stat.label}
          className={`bg-white rounded-lg border shadow-sm border-l-4 ${stat.borderColor} p-4`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{stat.label}</p>
              <p className="text-2xl font-bold">{stat.value}</p>
            </div>
            <div
              className={`w-12 h-12 rounded-xl ${stat.bgColor} flex items-center justify-center`}
            >
              <stat.icon className={`w-6 h-6 ${stat.iconColor}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
